<!--
 * @Author: vince
 * @Date: 2021-08-18 09:23:11
 * @LastEditors: vince
 * @LastEditTime: 2021-09-07 09:18:35
 * @Description:
-->
<template>
  <el-select size="small" v-if="controlType == 'select'" v-model="model" :disabled="disabled" :multiple="multiple" remote
              placeholder="请选择" value-key="value" :clearable="clearable" >
    <el-option v-for="item in options" :label="item.name" :value="item.value" :key="item.name"></el-option>
  </el-select>
  <!-- <el-checkbox-group v-else-if="controlType=='checkbox'" v-model="disciplineTemp" @change="change">
		<el-checkbox :label="item" v-for="(item,index) in options" :key="index">{{item.disciplineName}}</el-checkbox>
	</el-checkbox-group> -->
</template>

<script>
import { fileTypeList } from '../../utils'
export default {
  name: "fileTypeSelector",
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      options: fileTypeList,
      list: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      }
    }
  },
  props: {
    controlType: {
      type: String,
      default: "select"
    },
    value: {
      type: Array | Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  methods: {


  }
};
</script>

<style></style>
